import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from '@mui/icons-material/Close';
import MainStore from '../../../MainStore';
import './branch.css'
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import { Button } from '@mui/material';

export default class BranchSelect extends Component {

    constructor(props) {
        super(props);

        this.state = {
            branchs: [],
            isOpen: false,
            name: !!props.name ? props.name : '',
            id: !!props.id ? props.id : '',
            color: !!props.color ? props.color : '',
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadBranches = this.loadBranches.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.name !== this.props.name) {
            this.setState({ name: this.props.name });
        }
    }

    handleInputChange(e) {
        this.setState({ name: e.target.value });
        this.loadBranches(e.target.value);
    }

    loadBranches(v) {
        var scope = this;
        fetchWithAuth('api/Branch?name=' + v + '&accountId=' + this.props.accountId,
            null,
            "",
            (result) => {
                scope.setState({ branchs: result });
            },
            "GET"
        )
    }

    handleClear() {
        this.setState({ name: '', id: '', color: '', isOpen: false });
        this.props.handleSelect({ name: '', id: '', color: '' });
    }

    handleOpen(e) {
        this.setState({ isOpen: true });
        this.loadBranches('');
    }

    handleBlur(e) {
        this.setState({ isOpen: false });
    }

    render() {

        var branchs = this.state.branchs.map(p => <div className="branch-label" style={{ "background" : p.color}} key={p.id} onMouseDown={e => { this.setState({ name: p.name, id: p.id, color: p.color, isOpen: false }); this.props.handleSelect({ name: p.name, id: p.id, color: p.color }); }} value={p.id}>{p.name}</div>);
        return (
            <div>
                {!this.state.id && <Button onClick={this.handleOpen}>Выбрать ветку</Button>}
                {this.state.id && <div className="branch-label" style={{ "background": this.state.color }}>{this.state.name}<IconButton className="branch-clear-button" onClick={this.handleClear} size="large"> <CloseIcon /> </IconButton></div>}
                
                {this.state.isOpen &&
                    <div className="branch-list clearfix">
                        {branchs}
                    </div>
                }
            </div>
        );
    }
}
